module.exports = __webpack_public_path__ + "static/service-upsell-card-1093428f2f672d973b225246741bd28a.png";